import { signOut } from "@firebase/auth";
import { auth } from "../../config/firebaseConfig";

export async function signOutUser(): Promise<void> {
  try {
    await signOut(auth);
  } catch (error) {
    console.log(error);
  }
}
